






import { Add as AddIcon, Instagram as InstagramIcon } from '@mui/icons-material';
import {
  Button, Checkbox, Dialog, DialogActions, DialogContent,
  DialogTitle, FormControlLabel, FormGroup, TextField, Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import BrandHeader from './BrandHeader';
import Navbar from './Navbar';

const MyPlan = () => {
  const [brandPlans, setBrandPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [brandBackgroundImage, setBrandBackgroundImage] = useState('');
  const [openModal, setOpenModal] = useState(false);
  const [planName, setPlanName] = useState('');
  const [ListName, setListName] = useState('');
  const [brandName, setBrandName] = useState('');
  const [addInfluencersBySearch, setAddInfluencersBySearch] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchBrandPlans = async () => {
      try {
        const userId = localStorage.getItem('brandID');
        if (!userId) {
          setError('User ID not found');
          setLoading(false);
          return;
        }

        const response = await fetch(`https://server-side-influencer.onrender.com/brand/plans/${userId}`);
        const data = await response.json();

        if (data && data.data && data.data.brandPlans) {
          setBrandPlans(data.data.brandPlans);
          setBrandBackgroundImage(data.data.brandBackgroundImage);
        } else {
          setError('No brand plans found');
        }
      } catch (error) {
        setError('Error fetching brand plans: ' + error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBrandPlans();
  }, []);

  const handleCreatePlan = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleSubmit = () => {
    if (!planName || !brandName || !ListName) {
      toast.error('Please fill in all fields!', {
        position: "bottom-center",
        autoClose: 5000,
      });
      return;
    }

    navigate('/planlist', {
      state: {
        planName,
        brandName,
        ListName
      },
    });
    setOpenModal(false);
  };

  const handleViewPlan = (planName, brandName) => {
    navigate('/veiwplans', {
      state: { planName, brandName },
    });
  };

  return (
    <div className="flex h-screen mb-0 justify-center items-center w-full">
      <div className="text-white fixed top-0 left-0 bottom-0 z-50">
        <Navbar />
      </div>

      <div className="h-screen ml-0 w-full">
        <BrandHeader page="campaign reports" />
        <div className="ml-0 flex justify-center items-start w-full h-screen pt-20">
          {/* <div className="relative w-full max-w-7xl mx-auto"> */}
          <div className="relative w-full max-w-7xl sm:max-w-2xl md:max-w-2xl lg:max-w-6xl mx-auto">

            <div className="mb-6 w-full flex justify-between items-center p-6">
            <h1 className="text-lg sm:text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 ml-4 sm:ml-10">
  Plan and List
</h1>
 <button
                type="button"
                className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 flex items-center whitespace-nowrap"
                onClick={handleCreatePlan}
              >
                <AddIcon />
                Create Plan
              </button> 
            </div>

            {/* Table with loading & empty handlingssamanan  */}
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg w-40% ml-5">
              <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                  <tr>
                    <th className="px-6 py-3  whitespace-nowrap">Profile</th>
                    <th className="px-6 py-3  whitespace-nowrap">Plan Name</th>
                    <th className="px-6 py-3  whitespace-nowrap">Platform</th>
                    <th className="px-6 py-3  whitespace-nowrap">Total Influencers</th>
                    <th className="px-6 py-3  whitespace-nowrap">Total List</th>
                    <th className="px-6 py-3  whitespace-nowrap">Created By</th>
                    <th className="px-6 py-3  whitespace-nowrap">Created On</th>
                    <th className="px-6 py-3  whitespace-nowrap">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    [...Array(5)].map((_, i) => (
                      <tr key={i}>
                        <td colSpan="8" className="px-6 py-4">
                          <Skeleton height={50} width="100%" />
                        </td>
                      </tr>
                    ))
                  ) : brandPlans.length === 0 ? (
                    <tr>
                      <td colSpan="8" className="text-center py-6 text-xl text-gray-600">
                        No plan and list created yet
                      </td>
                    </tr>
                  ) : (
                    brandPlans.map((plan, index) => (
                      <tr key={index} className="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700 border-gray-200">
                        <td className="px-6 py-4 flex items-center">
                          <img
                            src={brandBackgroundImage}
                            alt="Brand Background"
                            className="w-10 h-10 rounded-full"
                          />
                          <span className="ml-2 text-sm text-gray-600">{plan.influencerDetails[0]?.brandname}</span>
                        </td>
                        <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                          {plan.planName}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <InstagramIcon sx={{ color: '#9b4dca', fontSize: 30 }} /> Instagram
                        </td>
                        <td className="px-6 py-4">{plan.totalInfluencers}</td>
                        <td className="px-6 py-4">{plan.totalListNames}</td>
                        <td className="px-6 py-4">Me</td>
                        <td className="px-6 py-4 whitespace-nowrap">{plan.influencerDetails[0]?.createdAt}</td>
                        <td className="px-6 py-4">
                          <button
                            onClick={() => handleViewPlan(plan.planName, plan.influencerDetails[0]?.brandname)}
                            className="font-medium text-blue-600 dark:text-blue-500 hover:underline whitespace-nowrap"
                          >
                            View Plan
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Create Plan Modals */}
        <Dialog open={openModal} onClose={handleCloseModal}>
          <DialogTitle>
            <strong style={{ color: 'black' }}>Create Plan</strong>
          </DialogTitle>
          <DialogContent>
            <TextField
              label="Name of Plan"
              variant="outlined"
              fullWidth
              margin="normal"
              value={planName}
              onChange={(e) => setPlanName(e.target.value)}
            />
            <TextField
              label="Name of list"
              variant="outlined"
              fullWidth
              margin="normal"
              value={ListName}
              onChange={(e) => setListName(e.target.value)}
            />
            <TextField
              label="Brand Name"
              variant="outlined"
              fullWidth
              margin="normal"
              value={brandName}
              onChange={(e) => setBrandName(e.target.value)}
            />
            <Typography variant="body2" color="textSecondary" gutterBottom>
              I want to add influencers by:
            </Typography>
            <FormGroup>
              <FormControlLabel
                control={<Checkbox checked={addInfluencersBySearch} onChange={(e) => setAddInfluencersBySearch(e.target.checked)} />}
                label=" searching influencers from Smesh"
              />
            </FormGroup>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseModal} color="secondary">Cancel</Button>
            <Button onClick={handleSubmit} color="primary">Create</Button>
          </DialogActions>
        </Dialog>
      </div>

      <ToastContainer />
    </div>
  );
};

export default MyPlan;
